/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const linkHubSpotCompanyDataSchema = z.object({
	hubspotCompanyId: z.string(),
	force: z.boolean().optional().default(false),
})

export type LinkHubSpotCompanyDataSchema = z.infer<typeof linkHubSpotCompanyDataSchema>
